/**
 * @generated SignedSource<<d2918e0417b0972cc008e21f0f93d676>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdatePopupGroupSetInput = {
  clientMutationId?: string | null;
  popupGroupSetId: string;
  name: string;
  memo?: string | null;
};
export type PopupGroupSetEditFormContainer_Mutation$variables = {
  input: UpdatePopupGroupSetInput;
};
export type PopupGroupSetEditFormContainer_MutationVariables = PopupGroupSetEditFormContainer_Mutation$variables;
export type PopupGroupSetEditFormContainer_Mutation$data = {
  readonly updatePopupGroupSet: {
    readonly popupGroupSet: {
      readonly id: string;
      readonly name: string;
      readonly memo: string | null;
    } | null;
  } | null;
};
export type PopupGroupSetEditFormContainer_MutationResponse = PopupGroupSetEditFormContainer_Mutation$data;
export type PopupGroupSetEditFormContainer_Mutation = {
  variables: PopupGroupSetEditFormContainer_MutationVariables;
  response: PopupGroupSetEditFormContainer_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdatePopupGroupSetPayload",
    "kind": "LinkedField",
    "name": "updatePopupGroupSet",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PopupGroupSet",
        "kind": "LinkedField",
        "name": "popupGroupSet",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "memo",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PopupGroupSetEditFormContainer_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PopupGroupSetEditFormContainer_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "28428dd812b396e2b53e74d0e7cc7f33",
    "id": null,
    "metadata": {},
    "name": "PopupGroupSetEditFormContainer_Mutation",
    "operationKind": "mutation",
    "text": "mutation PopupGroupSetEditFormContainer_Mutation(\n  $input: UpdatePopupGroupSetInput!\n) {\n  updatePopupGroupSet(input: $input) {\n    popupGroupSet {\n      id\n      name\n      memo\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "229660bc2e75d536eb73cd86f3e6b8d1";

export default node;
